import React from 'react';

const Privacy = () => (
  <main className="max-w-3xl mx-auto px-4 py-20 text-gray-800 dark:text-gray-200">
    <h1 className="text-3xl sm:text-4xl font-bold mb-6">Politica de confidențialitate</h1>
    <p className="mb-4">Ne angajăm să protejăm datele tale personale. Această politică explică ce date colectăm, cum le folosim și ce drepturi ai tu.</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">1. Ce date colectăm</h2>
    <p className="mb-4">Date de identificare și contact (nume, email, telefon), informații despre stilul de viață/obiective (prin chestionar), mesajele schimbate pe WhatsApp/email și date tehnice minime (cookie-uri esențiale).</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">2. De ce folosim datele</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>pentru a crea planuri personalizate de antrenament și nutriție;</li>
      <li>pentru comunicare și suport (WhatsApp/email);</li>
      <li>pentru facturare/contabilitate și respectarea obligațiilor legale;</li>
      <li>pentru îmbunătățirea serviciilor (feedback anonim).</li>
    </ul>

    <h2 className="text-xl font-semibold mt-6 mb-2">3. Baza legală</h2>
    <p className="mb-4">Contractul (prestarea serviciilor), consimțământul tău (ex. newsletter), interesul legitim (îmbunătățirea serviciilor) și obligații legale (contabilitate).</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">4. Cât timp păstrăm datele</h2>
    <p className="mb-4">Datele sunt păstrate pe durata colaborării și încă 24 luni după încetare, cu excepția documentelor fiscale ce se păstrează conform legii.</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">5. Cu cine partajăm datele</h2>
    <p className="mb-4">Nu vindem datele. Le partajăm doar cu furnizori necesari (aplicația de antrenament, instrumente de e-mail/hosting), sub acorduri de confidențialitate și doar la nevoie.</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">6. Drepturile tale</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>acces, rectificare, ștergere;</li>
      <li>restricționare sau opoziție;</li>
      <li>portabilitatea datelor;</li>
      <li>retragerea consimțământului pentru comunicări de marketing;</li>
      <li>plângere la ANSPDCP, dacă este cazul.</li>
    </ul>

    <h2 className="text-xl font-semibold mt-6 mb-2">7. Securitate</h2>
    <p className="mb-4">Aplicăm măsuri tehnice și organizatorice rezonabile pentru protecția datelor (acces restricționat, parole, criptare acolo unde este disponibilă).</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">8. Contact</h2>
    <p className="mb-4">Pentru orice solicitări legate de date, ne poți scrie la <a href="mailto:catadorca@yahoo.com" className="text-primary underline">catadorca@yahoo.com</a>.</p>
  </main>
);

export default Privacy; 